export var Plugins;
(function (Plugins) {
    Plugins["EMOTES"] = "Emotes";
    Plugins["IMAGE"] = "Image";
    Plugins["GALLERY"] = "Gallery";
    Plugins["VIDEO"] = "Video";
    Plugins["LINK"] = "Link";
    Plugins["MENTION"] = "Mention";
    Plugins["HASHTAG"] = "Hashtag";
    Plugins["TEXT_TOOLS"] = "TextTools";
    Plugins["GIPHY"] = "wix-draft-plugin-giphy";
})(Plugins || (Plugins = {}));
//# sourceMappingURL=plugins.js.map